/**
 *
 * v.1.0  10/09/25  Inicial
 * v.1.1  20/09/25 Añadida funcion formatear fecha y su aplicacion en onBlur y onPaste*/

import React from 'react'
import PropTypes from 'prop-types';
import {getFormattedDateFromTimestamp} from "../utils/DateUtils";


class InputCodigoId extends React.Component {
    //Se espera una cadena dd/mm/yyyy

    constructor(props) {
        super(props)
        this.state = {
            fechaCadena: this.transformarValorEnFechaCadena(props.valor),
            valido: false,
            error: null,
            tocado: false, //El usuario ha escrito
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.valor !== this.props.valor) {
            this.setState({
                fechaCadena: this.transformarValorEnFechaCadena(this.props.valor)
            });
        }
    }

    handleChange = (event) => {
        //Aqui hacemos las comprobacionea
        // Solo dígitos y limitar longitud
        let fechaCadena = event.target.value;
        let resultado= this.validarFecha(fechaCadena);
        this.setState({
            fechaCadena: fechaCadena,
            valido: resultado.valido,
            mensaje: resultado.mensaje,
            tocado: true,
        });
        
    };


    handleBlur = () => {
        let { fechaCadena} = this.state;
        let fechaFormateada = this.formatearFecha(fechaCadena);
        let resultado = this.validarFecha(fechaFormateada);
        this.setState({
            fechaCadena: fechaFormateada,
            valido: resultado.valido,
            mensaje: resultado.mensaje
        });

        if (resultado.valido && this.props.onChange) {
            let valorTimestamp= this.toTimestamp(fechaFormateada);
            this.props.onChange(valorTimestamp);
        }

    };

    handlePaste = (event) => {
        event.preventDefault();
        let pastedText = (event.clipboardData || window.clipboardData).getData("text");
        if (pastedText) {
            pastedText = pastedText.trim();
            // Normalizamos separadores (ej: 08-09-2025 -> 08/09/2025)
            pastedText = pastedText.replace(/[-.]/g, "/");
            // 👉 Reformateamos
            let fechaFormateada = this.formatearFecha(pastedText);
            let resultado = this.validarFecha(fechaFormateada);
            this.setState({
                fechaCadena: fechaFormateada,
                valido: resultado.valido,
                mensaje: resultado.mensaje,
                tocado: true
            });
        }
    };

    transformarValorEnFechaCadena = (valor) => {
        let fechaCadena= "";
        if (typeof valor == 'string')
            fechaCadena= valor;
        if (typeof valor === 'number')
            fechaCadena= getFormattedDateFromTimestamp(valor);
        return fechaCadena;
    }
    validarFecha = (fechaCadena) => {
        if (!fechaCadena|| fechaCadena.trim() === '')
            return { valido: false, mensaje: 'La fecha está vacía' };
        const parts = fechaCadena.split('/');
        if (parts.length !== 3)
            return { valido: false, mensaje: 'Formato debe ser dd/mm/yyyy' };
        const [ddS, mmS, yyyyS] = parts;
        if (!(ddS.length === 2 && mmS.length === 2 && (yyyyS.length === 2 || yyyyS.length === 4))) {
            return { valido: false, mensaje: 'Formato dd/mm/aaaa (ej. 08/09/2025)' };
        }
        const day = parseInt(ddS, 10);
        const month = parseInt(mmS, 10);
        let year = parseInt(yyyyS, 10);
        if (yyyyS.length === 2) year += (year <= 30 ? 2000 : 1900);

        if (isNaN(day) || isNaN(month) || isNaN(year))
            return { valido: false, mensaje: 'Partes no numéricas' };
        if (year < 1900 || year > 9999)
            return { valido: false, mensaje: 'Año fuera de rango (1900-9999)' };
        if (month < 1 || month > 12)
            return { valido: false, mensaje: 'Mes debe estar entre 01 y 12' };
        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth)
            return { valido: false, mensaje: `Día inválido para el mes: máximo ${daysInMonth}` };
        return { valido: true, mensaje: null };
    };

    formatearFecha = (fechaCadena) => {
        if (!fechaCadena)
            return "";

        // Quitamos todo lo que no sea dígito
        let soloNumeros = fechaCadena.replace(/\D/g, "");

        if (soloNumeros.length < 6)
            return fechaCadena; // demasiado corto

        let dd = soloNumeros.substring(0, 2);
        let mm = soloNumeros.substring(2, 4);
        let yyyy = soloNumeros.substring(4);

        // Si el año es de 2 dígitos lo expandimos
        if (yyyy.length === 2) {
            let y = parseInt(yyyy, 10);
            yyyy = (y <= 30 ? "20" : "19") + yyyy;
        }

        return `${dd}/${mm}/${yyyy}`;
    };

    toTimestamp = (formatted) => {
        if (!formatted)
            return null;
        const [dd, mm, yyyy] = formatted.split('/');
        if (!dd || !mm || !yyyy)
            return null;
        const date = new Date(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10));
        return date.getTime();
    };

    render() {
        const {className} = this.props;
        const {fechaCadena, mensaje, valido, tocado} = this.state;
        //console.log("InputFecha - RENDER");
        //console.log("fechaCandena: ", fechaCadena);

        // Estilos base
        let inputStyle = {
            border: "1px solid #ccc",
            padding: "6px 8px",
            borderRadius: "4px",
            outline: "none",
            width: "100%"
        };
        if (tocado) {
            if (valido) {
                inputStyle.border = "2px solid green";
            } else {
                inputStyle.border = "2px solid red";
            }
        }

        return (
            <div className={className || 'w-full max-w-sm'}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <input
                        style={inputStyle}
                        type="text"
                        value={fechaCadena}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        onPaste={this.handlePaste}
                        maxLength={10}
                    />
                </div>
                {mensaje && <p id="date-error" style={{ color: "red", fontSize: "0.9em", marginTop: "4px" }}>{mensaje}</p>}
            </div>

        );
    }

}


InputCodigoId.propTypes = {
    className: PropTypes.string,
    valor: PropTypes.string, //El componente espera una fecha en timestamp o en cadena 'dd/mm/yyyy'
    onChange: PropTypes.func, //El componente devuelve la fecha en timestamp

}

export default InputCodigoId